import React, { Component } from 'react'
import {
    Button,
    Modal,
    Row,
    Col,
    Form,
    Container,
    Badge,
    ButtonGroup,
  } from "react-bootstrap";
  import * as Icon from "react-bootstrap-icons";
  import { Toast } from "primereact/toast";
import axios from "axios";
import { APIKEY } from "../../Config/Config";
export default class Login extends Component {
    constructor() {
        super();
        this.editor = React.createRef();
        this.state = {
            email:'',
            password:"",
            Errormessage:""
        };
      
      }

      // Onchange
  onChangeCategory = ({ target: { name, value } }) => {
    this.setState({
      [name]: value,
    });
    console.log("onchnage", value);
  };

//   Submit
LoginSubmit=(event)=>{
    event.preventDefault();
    axios.post(`${APIKEY}/Users/login`,{
        Email:this.state.email,
        Password:this.state.password
      }).then((Response)=>{
        if(Response.data.token){
            localStorage.setItem('Hrtech_token', JSON.stringify(Response.data.token));
            this.toast.show({
              severity: "success",
              summary: "Login Successfully",
              detail: `${Response.data.message}`,
              life: 3000,
            });
            window.location.href = '/dashboard';

        }else{
          this.toast.show({
            severity: "error",
            summary: "Error Message",
            detail: `${Response.data.message}`,
            life: 3000,
          });
            this.setState({
                Errormessage:Response.data.message
            })
        }
        console.log("dataaaa",Response)

    })
}
  render() {
    return (
      <div>
        
         {/* <Container>
            <h5>{this.state.Errormessage}</h5>
                  <Form onSubmit={this.LoginSubmit}>
                    <Row>
                      <Col md={3}>
                        <Form.Group
                          className="mb-3"
                          controlId="exampleForm.ControlInput1"
                        >
                          <Form.Label>User Name</Form.Label>
                          <Form.Control
                            type="text"
                            name="email"
                            value={this.state.email}
                            onChange={this.onChangeCategory}
                            placeholder=""
                            required
                          />
                        </Form.Group>
                      </Col>
                      <Col md={3}>
                        <Form.Group
                          className="mb-3"
                          controlId="exampleForm.ControlInput1"
                        >
                          <Form.Label>Password</Form.Label>
                          <Form.Control
                            type="password"
                            name="password"
                            value={this.state.password}
                            onChange={this.onChangeCategory}
                            placeholder=""
                            required
                          />
                        </Form.Group>
                      </Col>
                      
                    </Row>

                    <Row>
                      <div className="d-flex justify-content-end">
                        <br></br>
                        <Button
                          variant="danger"
                          className="me-2"
                          onClick={this.ModelClose}
                        >
                          Cancel
                        </Button>
                        <Button variant="primary" type="submit">
                          {this.state.ID ? "Update" : "Submit"}
                        </Button>
                      </div>
                    </Row>
                  </Form>
                </Container> */}
              <Toast ref={(el) => (this.toast = el)} />

<section className="vh-100">
  <div className="container-fluid h-custom">
    <div className="row d-flex justify-content-center align-items-center h-100">
      <div className="col-md-9 col-lg-6 col-xl-5">
        <img src="https://www.hrtech.sg/assets/img/logo.png" className="img-fluid" alt="Sample image" />
      </div>
      <div className="col-md-8 col-lg-6 col-xl-4 offset-xl-1">
        <form onSubmit={this.LoginSubmit}>
          
          {/* Email input */}
          <div className="form-outline mb-4">
          <label className="form-label" htmlFor="form3Example3">Email address</label>

            <input type="email" id="form3Example3"  name="email"
                            value={this.state.email}
                            onChange={this.onChangeCategory} className="form-control form-control-lg" placeholder="Enter a valid email address" />
          </div>
          {/* Password input */}
          <div className="form-outline mb-3">
          <label className="form-label" htmlFor="form3Example4">Password</label>

            <input type="password" id="form3Example4"  name="password"
                            value={this.state.password}
                            onChange={this.onChangeCategory} className="form-control form-control-lg" placeholder="Enter password" />
          </div>
          <div className="d-flex justify-content-between align-items-center">
            {/* Checkbox */}
            <div className="form-check mb-0">
            <label className="form-check-label" htmlFor="form2Example3">

              <input className="form-check-input me-2" type="checkbox" defaultValue id="form2Example3" />
                Remember me
              </label>
            </div>
            <a href="#!" className="text-body">Forgot password?</a>
          </div>
          <div className="text-center text-lg-start mt-4 pt-2">
            <button type="submit" className="btn btn-primary btn-lg" style={{paddingLeft: '2.5rem', paddingRight: '2.5rem'}}>Login</button>
            <p className="small fw-bold mt-2 pt-1 mb-0">Don't have an account? <a href="/register" className="link-danger">Register here</a></p>
          </div>
        </form>
      </div>
    </div>
  </div>

</section>

      </div>
    )
  }
}
